import { render, staticRenderFns } from "./NotificationsToAcceptDialog.vue?vue&type=template&id=7a61dac8&scoped=true"
import script from "./NotificationsToAcceptDialog.vue?vue&type=script&lang=js"
export * from "./NotificationsToAcceptDialog.vue?vue&type=script&lang=js"
import style0 from "./NotificationsToAcceptDialog.vue?vue&type=style&index=0&id=7a61dac8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a61dac8",
  null
  
)

export default component.exports